import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["subject"];

  connect() {
    this._outsideClickListener = this.handleOutsideClick.bind(this);
    document.addEventListener("click", this._outsideClickListener);
  }

  disconnect() {
    document.removeEventListener("click", this._outsideClickListener);
  }

  handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.hide();
    }
  }

  hide() {
    this.subjectTarget.classList.add("hidden");
  }

  toggle() {
    this.subjectTarget.classList.toggle("hidden");
  }
}
